import { render, staticRenderFns } from "./TileProductSpeed5m.vue?vue&type=template&id=55dce488"
import script from "./TileProductSpeed5m.vue?vue&type=script&lang=js"
export * from "./TileProductSpeed5m.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports